import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import * as Sentry from "@sentry/angular";
import { Integrations } from "@sentry/tracing";

import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";

Sentry.init({
  dsn:
    "https://95c1dc6e8fc9430d87c61bc78657a4c8@o457352.ingest.sentry.io/6067751",
  integrations: [
    new Integrations.BrowserTracing({
      tracingOrigins: [
        "https://preprod.canalwalk.co.za",
        "https://canalwalk.co.za",
        "https://preprod.clearwatermall.co.za",
        "https://clearwatermall.co.za",
      ],
      routingInstrumentation: Sentry.routingInstrumentation,
    }),
  ],
  tracesSampleRate: 0.65,
});

if (environment.production) {
  enableProdMode();
}

document.addEventListener("DOMContentLoaded", () => {
  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => console.log(err));
});
